enum LocalStorageKeys {
  provider = 'p-provider',
  p_access_token = 'p-access_token',
  p_refresh_token = 'p-refresh_token',
}

export default LocalStorageKeys;
